// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"144":"48a29e74","248":"1a45f8a3","945":"05486fa1"}[chunkId] + ".js";
};